import Authors from "../data/authors.json";

export const DEFAULT_AUTHOR_ID = "redakcja";

function normalize(value) {
	return String(value || "").trim().toLocaleLowerCase("pl-PL");
}

export function getAuthorById(id) {
	const key = String(id || "").trim();
	return key && Authors[key] ? Authors[key] : null;
}

export function getAuthorByReference(reference) {
	const value = String(reference || "").trim();

	if (!value) {
		return null;
	}

	if (Authors[value]) {
		return Authors[value];
	}

	const normalized = normalize(value);

	return (
		Object.values(Authors).find((author) => {
			return [
				author.id,
				author.legacyVariable,
				author.name,
				author.slug,
				author.path,
				author.url,
			]
				.filter(Boolean)
				.some((candidate) => normalize(candidate) === normalized);
		}) || null
	);
}

export function resolveArticleAuthor(meta = {}) {
	const candidates = [meta.authorId, meta.authorVariable, meta.author];

	for (const candidate of candidates) {
		const author = getAuthorByReference(candidate);

		if (author) {
			return author;
		}
	}

	return getAuthorById(DEFAULT_AUTHOR_ID);
}

export function normalizeArticleAuthorMeta(meta = {}) {
	const author = resolveArticleAuthor(meta);

	if (!author) {
		return { ...meta };
	}

	return {
		...meta,
		authorId: author.id,
		author: author.name,
		authorVariable: author.legacyVariable || "",
		authorProfile: author,
	};
}

export function normalizeAuthorFrontmatterForSave(meta = {}) {
	const selectedByName = meta.author ? getAuthorByReference(meta.author) : null;
	const author =
		selectedByName ||
		getAuthorByReference(meta.authorId) ||
		getAuthorByReference(meta.authorVariable) ||
		getAuthorById(DEFAULT_AUTHOR_ID);

	const next = {
		...meta,
		authorId: author.id,
	};

	delete next.author;
	delete next.authorVariable;
	delete next.authorProfile;

	return next;
}

export function authorToSchema(authorOrMeta) {
	const author =
		authorOrMeta?.id && getAuthorById(authorOrMeta.id)
			? getAuthorById(authorOrMeta.id)
			: resolveArticleAuthor(authorOrMeta || {});

	if (!author) {
		return null;
	}

	return {
		"@type": author.type || "Person",
		name: author.name,
		url: author.url || undefined,
		image: author.image || undefined,
		description: author.description || undefined,
	};
}

export function getAuthorOptions() {
	return Object.values(Authors).map((author) => ({
		id: author.id,
		name: author.name,
		legacyVariable: author.legacyVariable || "",
	}));
}

export { Authors };
